'use client';

import Icon from '@/components/ui/AppIcon';
import { getBookingUrl } from '@/lib/booking';
import { useLocale } from '@/context/LocaleContext';
import { getPublicStrings } from '@/i18n/public';

export default function MobileBookingBar() {
  const href = getBookingUrl('mobile_bar');
  const external = href.startsWith('http');
  const locale = useLocale();
  const copy = getPublicStrings(locale).mobileBookingBar;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] border-t border-border bg-foreground p-3 shadow-[0_-4px_24px_rgba(0,0,0,0.12)] lg:hidden safe-area-pb">
      <a
        href={href}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-md bg-gold px-4 text-xs font-black uppercase tracking-[0.16em] text-gold-foreground hover:bg-gold/90"
      >
        <Icon name="CalendarDaysIcon" variant="solid" size={18} />
        {copy.cta}
      </a>
    </div>
  );
}
